(() => {
/* Match the existing Sam FAQ's 500ms expansion and easing, preserving native
   details/summary keyboard interaction and the no-JavaScript fallback. */
class SamBrandFAQ extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.animations = new Map();
    this.items = [...this.querySelectorAll('details')];
    this.addEventListener('shopify:block:select', event => {
      const item = event.target.closest('details');
      if (item) this.setOpen(item, true);
    }, { signal: this.controller.signal });
    this.items.forEach((item) => {
      item.removeAttribute('name');
      item.querySelector('summary').addEventListener('click', (event) => {
        event.preventDefault();
        const open = !item.open || item.hasAttribute('data-closing');
        this.items.forEach((other) => this.setOpen(other, other === item && open));
      }, { signal: this.controller.signal });
    });
  }

  setOpen(item, open) {
    if (item.open === open && !this.animations.has(item)) return;
    const start = item.getBoundingClientRect().height;
    this.animations.get(item)?.cancel();
    item.style.height = '';
    item.open = true;
    item.toggleAttribute('data-closing', !open);
    const end = open ? item.getBoundingClientRect().height : item.querySelector('summary').getBoundingClientRect().height + 1;
    const finish = () => {
      item.open = open;
      item.removeAttribute('data-closing');
      item.style.overflow = '';
      this.animations.delete(item);
    };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finish();
      return;
    }
    item.style.overflow = 'hidden';
    const animation = item.animate([{ height: `${start}px` }, { height: `${end}px` }], {
      duration: 500, easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
    });
    this.animations.set(item, animation);
    animation.onfinish = finish;
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.animations?.forEach((animation) => animation.cancel());
  }
}
if (!customElements.get('sam-brand-faq')) customElements.define('sam-brand-faq', SamBrandFAQ);

})();
